import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import DashboardLayout from "@/components/DashboardLayout";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { LogOut } from "lucide-react";
import { toast } from "sonner";

const ACCESS_LABEL = { active: "Akun Aktif", trial: "Masa Percobaan", expired: "Akses Kedaluwarsa", admin: "Admin" };

export default function Profil() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    toast.success("Anda telah keluar.");
    navigate("/login");
  };

  const memberSince = user?.created_at ? new Date(user.created_at).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" }) : "-";

  return (
    <DashboardLayout>
      <div className="animate-fade-up max-w-2xl">
        <h1 className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight text-ink" data-testid="profil-header">
          Profil
        </h1>
        <p className="mt-3 text-base text-ink-soft">Informasi akun Anda.</p>

        <div className="mt-8 rounded-2xl border border-borderc bg-white p-6 sm:p-8" data-testid="profil-card">
          <div className="flex items-center gap-4">
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-brand text-xl font-bold text-white">
              {(user?.name || "U").split(" ").map((n) => n[0]).slice(0, 2).join("").toUpperCase()}
            </span>
            <div>
              <div className="font-heading text-lg font-semibold text-ink" data-testid="profil-name">{user?.name}</div>
              <div className="text-sm text-ink-muted" data-testid="profil-email">{user?.email}</div>
              <span data-testid="profil-access-status" className="mt-1.5 inline-flex items-center rounded-full bg-brand/10 px-2.5 py-0.5 text-xs font-semibold text-brand">
                {ACCESS_LABEL[user?.access_status] || "Akun Aktif"}
              </span>
            </div>
          </div>

          <div className="mt-8 grid gap-5 sm:grid-cols-2">
            <div>
              <Label>Nama</Label>
              <Input className="mt-1.5 h-11 bg-slate-50" value={user?.name || ""} readOnly />
            </div>
            <div>
              <Label>Email</Label>
              <Input className="mt-1.5 h-11 bg-slate-50" value={user?.email || ""} readOnly />
            </div>
            <div>
              <Label>Bergabung sejak</Label>
              <Input className="mt-1.5 h-11 bg-slate-50" value={memberSince} readOnly />
            </div>
          </div>

          <div className="mt-8 border-t border-borderc pt-6">
            <Button onClick={handleLogout} variant="outline" data-testid="profil-logout" className="gap-2 border-red-200 text-red-600 hover:bg-red-50 hover:text-red-600">
              <LogOut className="h-4 w-4" /> Keluar dari akun
            </Button>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}
